var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.contact)?_c('div',[_vm._v("\n  "+_vm._s(_vm.contactName)+" |\n  "+_vm._s(_vm.description)+"\n  "),_c('AppShowCountry',{attrs:{"country":_vm.country,"show-ioc":false}}),_vm._v("\n  "+_vm._s(_vm.registryCode)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }